import * as actions from './stats-version-check.actions';

import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { Capacitor } from '@capacitor/core';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import { StatsVersionCheckI } from 'src/app/api/stats-version-check/stats-version-check.result.int';

export interface State {
    error: SharedErrorObjectI | null;
    loaded: boolean;
    loading: boolean;
    data: StatsVersionCheckI;
    isUpdated: boolean;
    platform: 'android' | 'ios' | 'web';
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
    isUpdated: false,
    platform: Capacitor.getPlatform() as 'android' | 'ios' | 'web',
};

export default createFeature({
    name: 'statsVersionCheck',
    extraSelectors: ({ selectData, selectPlatform, selectIsUpdated }) => ({
        isAndroid: createSelector(selectPlatform, (p) => p === 'android'),
        isApple: createSelector(selectPlatform, (p) => p === 'ios'),
        statusIsGreen: createSelector(selectData, selectIsUpdated, (d) => selectIsUpdated && d?.expireStatus === 'GREEN' || d?.expireStatus === null || d?.expireStatus === undefined),
        statusIsOrange: createSelector(selectData, (d) => d?.expireStatus === 'ORANGE'),
        statusIsYellow: createSelector(selectData, (d) => d?.expireStatus === 'YELLOW'),
        statusIsRed: createSelector(selectData, (d) => d?.expireStatus === 'RED'),
    }),
    reducer: createReducer(
        initialState,
        on(actions.error, (state: State, { error }): State => ({
            ...state,
            error,
            loaded: false,
            loading: false
        })),
        on(actions.reset, (state: State): State => ({
            ...state,
            data: null,
            error: null,
            loaded: false,
            loading: false
        })),
        on(actions.received, (state: State, { result }): State => ({
            ...state,
            data: result,
            error: null,
            loaded: true,
            loading: false,
        })),
        on(actions.load, (state: State, { query }): State => {
            let isUpdated = false;
            if (SpxStorage.getSetting(SharedStorageKeyEnum.lastBundleVersion) !== query.bundleVersion) {
                isUpdated = true;
                SpxStorage.setSetting(SharedStorageKeyEnum.lastBundleVersion, query.bundleVersion);
            }
            return ({
                ...state,
                loaded: false,
                loading: true,
                isUpdated,
            });
        })
    )
}
);
